import { render, staticRenderFns } from "./cv-tab.vue?vue&type=template&id=395c5165&scoped=true"
import script from "./cv-tab.vue?vue&type=script&lang=js"
export * from "./cv-tab.vue?vue&type=script&lang=js"
import style0 from "./cv-tab.vue?vue&type=style&index=0&id=395c5165&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "395c5165",
  null
  
)

export default component.exports